/**
 * Injection Rules Configuration
 *
 * Define rules for conditional script injection based on URL paths and custom conditions.
 */

import type { InjectionRule } from "@/types/injection-rules";
import { isLoggedIn } from "@/utils/auth";

export const injectionRules: InjectionRule[] = [
  {
    id: "vzgpt-bundle",
    scriptUrl: "/nextgendigital/sales/assistant/scripts/vzgpt-bundle.min.js",
    pathPattern: [
      "/expresspay/",
      "/nextgendigital/secure/*",
      "/digital/nsa/secure/ui/*",
      "/digital/nsa/nos/ui/*", // this is not load as we have condition to check loggedIn cookie
      "/nextgendigital/nos/*",
      "/support/*",
      "/sales/tys/*",
      "/sales/as/*",
    ],
    condition: isLoggedIn,
    priority: 10,
  },

  //   // Example 2: Multiple paths (array)
  //   {
  //     id: "support-script",
  //     scriptUrl: "https://cdn.example.com/support.js",
  //     pathPattern: [
  //       "/digital/nsa/secure/ui/support/signinlanding",
  //       "/support/*",
  //       "/digital/nsa/secure/ui/orders/*",
  //       "/digital/nsa/secure/ui/ngd/devices/*",
  //       "/digital/nsa/secure/ui/ngd/bill/*",
  //     ],
  //     priority: 5,
  //   },

  //   // Example 3: Single exact path with condition
  //   {
  //     id: "analytics-script",
  //     scriptUrl: "https://cdn.example.com/analytics.js",
  //     pathPattern: "/expresspay/",
  //     condition: () => {
  //       return localStorage.getItem("cookies-accepted") === "true";
  //     },
  //   },

  //   // Example 4: RegExp pattern
  //   {
  //     id: "checkout-script",
  //     scriptUrl: "https://cdn.example.com/checkout.js",
  //     pathPattern: /^\/digital\/nsa\/(secure|nos)\/ui\/.*/,
  //   },
];
